import axios from 'axios';

// URL de base de l'API - Utiliser l'URL de production si disponible, sinon fallback
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://api.africa4tourism.com/api';

// Création d'une instance axios avec configuration par défaut
const axiosInstance = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
    },
    withCredentials: false // Désactivé pour éviter les erreurs CORS avec le backend AWS
});

// Intercepteur de requête - Ajoute automatiquement le token JWT
axiosInstance.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');

        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }

        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Intercepteur de réponse - Gestion centralisée des erreurs
axiosInstance.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        // Gestion des erreurs 401 (Token invalide ou expiré)
        if (error.response?.status === 401) {
            console.error('Erreur 401 - Token invalide ou expiré');

            // Optionnel: Rediriger vers la page de login
            const currentPath = window.location.pathname;
            if (currentPath !== '/login') {
                // Nettoyer le token
                localStorage.removeItem('token');

                // Redirection vers login
                // window.location.href = '/login';
            }
        }

        // Gestion des erreurs CORS
        if (error.message === 'Network Error') {
            console.error('Erreur réseau - Vérifier la configuration CORS du backend');
        }

        return Promise.reject(error);
    }
);

export default axiosInstance;
